import { useContext } from "react";
import { CognitoContext } from "./Context";
// eslint-disable-next-line import/prefer-default-export
export const useAuth = () => useContext(CognitoContext);
